/*
 * Module for the Insurance Carriers' Coverages view
*/

rs.module("fund/configuration/insurancecarriers/coverages",

    ["controls/data/grid", "controls/components/event-banner"],

    function (gridModule, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, backendUrls, coveragesGridLrsApi) {

            var form = $.js(jsSelectors.form);

            // listen for clicks on the Add link
            form.js(jsSelectors.addLink).click(initializeFormForAdd);

            // reload grid when insurance type filter is changed
            form.js(jsSelectors.insuranceTypeSelectFilter).change(function () {

                // show loading spinner
                form.js(jsSelectors.spinner).show();

                clearErrors();

                gridModule.update(
                    backendUrls.getCoverages,
                    {
                        insuranceTypeKey: $(this).val(),
                        insuranceCarrierKey: $(this).data("insurancecarrierkey")
                    },
                    coveragesGridLrsApi.agGridApi,
                    function done(gridUpdate) {

                        // try to select the first row
                        coveragesGridLrsApi.selectFirstRow();

                        // if there are no selected rows, that means there are no rows to display, so initialize form for adding one
                        if (coveragesGridLrsApi.selectedRows.length == 0) {
                            initializeFormForAdd();

                            form.js(jsSelectors.deactivateAllLink).hide();
                        }
                        else {
                            form.js(jsSelectors.deactivateAllLink).show();
                        }

                        // update deactivate all link
                        form.js(jsSelectors.deactivateAllLink).attr("href", gridUpdate.context.deactivateAllUrl);

                        // update cancel link
                        form.js(jsSelectors.cancelLink).attr("href", gridUpdate.context.cancelUrl);

                        // hide loading spinner
                        form.js(jsSelectors.spinner).hide();
                    }
                );
            });

            var executeSelectionChanged;

            // On coverage row clicked, retrieve the coverage record and display for edit
            coveragesGridLrsApi.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (executeSelectionChanged && values.length > 0) {

                    clearErrors();

                    $.get(backendUrls.getCoverageForEdit, { insuranceCoverageKey: values[0] }).done(function (result) {

                        form.js(jsSelectors.coverageKeyHidden).val(result.insuranceCoverageKey);
                        form.js(jsSelectors.updateTokenHidden).val(result.updateToken);
                        form.js(jsSelectors.insuranceTypeKeyHidden).val(result.insuranceTypeKey);
                        form.js(jsSelectors.codeInput).val(result.coverageCode);
                        form.js(jsSelectors.descriptionInput).val(result.coverageDescription);
                    });
                }

                executeSelectionChanged = true;
            });

            //
            // Function to reset necessary fields for adding a new coverage
            //
            function initializeFormForAdd() {
                form.js(jsSelectors.coverageKeyHidden).val(-1);
                form.js(jsSelectors.updateTokenHidden).val(null);
                form.js(jsSelectors.insuranceTypeKeyHidden).val(0);
                form.js(jsSelectors.codeInput).val(null);
                form.js(jsSelectors.descriptionInput).val(null);

                coveragesGridLrsApi.selectedValues = null;

                clearErrors();
            }

            //
            // Clear event banner and field errors
            //
            function clearErrors() {
                // clear event banner
                eventBanner.removeAllMessages();

                // clear field errors
                form.js(jsSelectors.codeInput).clearErrors();
                form.js(jsSelectors.descriptionInput).clearErrors();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);